import select from './select';
export default function max(array, selector) {
    const values = select(array, selector);
    return Math.max(...values);
}
